import React from "react";

export default function RecentActivityPanel() {
  return (
    <div className="card">
      <div className="activity-feed">
        <div className="activity-feed-item">
          <div className="activity-dot" />
          <div>
            <div className="activity-title">Start in Documents</div>
            <div className="activity-text">
              Upload a PDF or open an existing request to continue work.
            </div>
          </div>
        </div>

        <div className="activity-feed-item">
          <div className="activity-dot" />
          <div>
            <div className="activity-title">Use Workspace Tabs</div>
            <div className="activity-text">
              Manage signers, placement, progress, audit, and revisions in one
              place.
            </div>
          </div>
        </div>

        <div className="activity-feed-item">
          <div className="activity-dot" />
          <div>
            <div className="activity-title">Monitor Analytics</div>
            <div className="activity-text">
              Watch drop-offs, SLA performance, and overall workflow health.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
